export default __webpack_public_path__ + "content/media/4.a3184598.jpg";